import * as React from "react";
import { MapPin, Building2, HeartPulse, Clock } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
const hospitalsData = [{
  id: "hadassah-ein-kerem",
  name: "הדסה עין כרם",
  badge: "מרכז רפואי מוביל",
  icon: Building2,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/hadassah_ein_kerem_hospital.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/hadassah_ein_kerem_hospital.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/hadassah_ein_kerem_hospital.png-wvc-sizes",
    alt: "בית החולים הדסה עין כרם בירושלים"
  },
  descriptionPart1: "בית החולים הדסה עין כרם, השוכן בנוף הפסטורלי של הרי ירושלים, נחשב לאחד המוסדות הרפואיים המובילים והמתקדמים ביותר במזרח התיכון. המרכז משלב מצוינות קלינית עם מחקר אקדמי פורץ דרך, ומעניק טיפול רפואי מקיף במגוון עצום של התמחויות. מטופלים מכל רחבי הארץ והעולם מגיעים להדסה עין כרם כדי לקבל מענה רפואי מורכב, החל מניתוחים חדשניים ועד לטיפולים אונקולוגיים מתקדמים. בסביבה רפואית אינטנסיבית זו, הצורך בהשגחה אישית וצמודה הוא קריטי להחלמה מהירה ובטוחה. אנו מציעים שירותי אחיות פרטיות ומטפלים סיעודיים מיומנים, הזמינים להעניק ליווי צמוד למאושפזים בכל מחלקות בית החולים. הצוות שלנו דואג לכל צרכיו הפיזיים והרגשיים של המטופל, החל מעזרה בהאכלה ורחצה, דרך השגחה על מדדים ועד למתן תמיכה מורלית בשעות הקשות. אנו מבינים את הלחץ והדאגה המלווים אשפוז של בן משפחה, ולכן אנו מתחייבים לספק שקט נפשי למשפחות. במקרים בהם נדרשת התערבות דחופה, אנו מספקים ",
  descriptionPart2: " לכל צורך סיעודי שעולה.",
  linkUrl: "/NursingCareProviderInJerusalemWithinFiveHoursPage"
}, {
  id: "hadassah-mount-scopus",
  name: "הדסה הר הצופים",
  badge: "רפואה קהילתית ותומכת",
  icon: HeartPulse,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/hadassah_mount_scopus_hospital.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/hadassah_mount_scopus_hospital.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/hadassah_mount_scopus_hospital.png-wvc-sizes",
    alt: "בית החולים הדסה הר הצופים בירושלים"
  },
  descriptionPart1: "קמפוס הדסה הר הצופים מהווה עוגן רפואי חיוני עבור תושבי צפון ומזרח ירושלים, ומציע שילוב ייחודי של רפואה מתקדמת באווירה קהילתית ותומכת. בית החולים מצטיין במיוחד במערך היולדות שלו, במחלקות הילדים, ובמרכז השיקום המוביל המסייע למטופלים לחזור לתפקוד מיטבי לאחר פציעות או מחלות קשות. האווירה המשפחתית בהר הצופים תורמת רבות לתהליך ההחלמה, אך לעיתים קרובות נדרשת תמיכה נוספת מעבר לזו שיכול לספק הצוות הרפואי העמוס. כאן אנו נכנסים לתמונה, עם שירותי השגחה פרטית המותאמים אישית לצרכי המאושפזים בהר הצופים. המטפלים המסורים שלנו משתלבים בשגרת המחלקה, ומבטיחים שהיקירים שלכם יקבלו את מלוא תשומת הלב, הנוחות והבטיחות במהלך שהותם בבית החולים. בין אם מדובר בהשגחת לילה לאחר ניתוח, או בליווי יומיומי בתהליך שיקום ארוך, אנו כאן כדי להקל על העומס המוטל על המשפחה. אם נקלעתם למצב חירום רפואי הדורש היערכות מהירה, פנו אלינו לקבלת ",
  descriptionPart2: " וצוות מקצועי שיתייצב לצידכם.",
  linkUrl: "/NursingCareProviderInJerusalemWithinFiveHoursPage"
}, {
  id: "shaare-zedek",
  name: "המרכז הרפואי שערי צדק",
  badge: "בלב ירושלים",
  icon: MapPin,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/shaare_zedek_medical_center.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/shaare_zedek_medical_center.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/shaare_zedek_medical_center.png-wvc-sizes",
    alt: "המרכז הרפואי שערי צדק בירושלים"
  },
  descriptionPart1: "המרכז הרפואי שערי צדק, הממוקם במיקום אסטרטגי בלב ירושלים, הוא בית החולים המרכזי והנגיש ביותר לתושבי העיר. שערי צדק חרט על דגלו את שילוב החדשנות הרפואית עם יחס אנושי, חומל ומכבד לכל מטופל. בית החולים מתגאה במרכזי מצוינות בתחומי הקרדיולוגיה, רפואת החירום, והגנטיקה, ומטפל באלפי חולים מדי יום. העומס הרב במחלקות מדגיש את החשיבות של ליווי אישי צמוד, במיוחד עבור קשישים או חולים מורכבים. שירותי הסיעוד הפרטי שלנו בשערי צדק נועדו לגשר על הפער הזה, ולהעניק למטופלים מעטפת של טיפול מסור ואישי. האחיות והמטפלים שלנו דואגים לנוחות המרבית של המאושפז, מסייעים בתקשורת מול הצוות הרפואי, ומוודאים שכל צרכיו נענים בזמן אמת. אנו מאמינים שנוכחות של דמות מטפלת קבועה ומרגיעה משפרת משמעותית את חווית האשפוז ותורמת להחלמה. לתיאום שירות מהיר ויעיל, גם בהתראה קצרה, צרו קשר לקבלת ",
  descriptionPart2: " המותאם במדויק למצבכם הרפואי והמשפחתי.",
  linkUrl: "/NursingCareProviderInJerusalemWithinFiveHoursPage"
}];
export default function LocationsAndPavilionsInJerusalem() {
  return <section id="מיקומים-וביתנות-בירושלים" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center max-w-3xl mx-auto">
          <Badge variant="secondary" className="mb-4">
            <MapPin className="ml-1 size-4" />
            פריסה ארצית, מומחיות ירושלמית
          </Badge>
          <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground mb-4">
            מיקומים וביתנות בירושלים
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            אנו מספקים שירותי סיעוד והשגחה פרטית בכל המרכזים הרפואיים המובילים בירושלים, עם זמינות מיידית וצוות מקצועי המכיר היטב את מחלקות האשפוז השונות.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {hospitalsData.map((hospital, i) => {
          const Icon = hospital.icon;
          return <Card key={hospital.id} data-index={i} className="flex flex-col overflow-hidden border-border shadow-md hover:shadow-lg transition-shadow duration-300">
                <div className="relative h-48 w-full overflow-hidden bg-muted">
                  <img src={hospital.image.src} data-wvc-srcset={hospital.image.srcset} data-wvc-sizes={hospital.image.sizes} alt={hospital.image.alt} loading="lazy" className="object-cover w-full h-full transition-transform duration-500 hover:scale-105" />
                  <div className="absolute top-4 right-4">
                    <Badge variant="default" className="shadow-sm">
                      {hospital.badge}
                    </Badge>
                  </div>
                </div>

                <CardHeader className="pb-4">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="p-2 bg-primary/10 rounded-lg text-primary">
                      <Icon className="size-6" />
                    </div>
                    <CardTitle className="text-2xl font-default text-foreground">
                      {hospital.name}
                    </CardTitle>
                  </div>
                </CardHeader>

                <CardContent className="flex-grow">
                  <p className="text-muted-foreground leading-relaxed text-justify font-default">
                    {hospital.descriptionPart1}
                    <Link to={hospital.linkUrl} className="text-primary font-semibold hover:underline underline-offset-4 inline-flex items-center gap-1 transition-colors">
                      <Clock className="size-4 inline" />
                      פתרון מיידי
                    </Link>
                    {hospital.descriptionPart2}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}